// Opens the time-entry editor (a drawer mounted once in the app shell) from
// anywhere: the registrations list, the dashboard, the command palette, the
// "n" shortcut.
//
//   entryEditor.open();                          // new entry
//   entryEditor.open({ entry });                 // edit
//   entryEditor.open({ defaults: { client_id } }); // new, prefilled

import type { TimeEntry } from '../types';
import type { EntryInput } from './data.svelte';

class EntryEditorState {
  isOpen = $state(false);
  entry = $state<TimeEntry | null>(null);
  defaults = $state<Partial<EntryInput>>({});
  /** Duplicate: prefill from an entry but create a new one. */
  duplicateOf = $state<TimeEntry | null>(null);

  open(opts: { entry?: TimeEntry | null; defaults?: Partial<EntryInput>; duplicate?: TimeEntry | null } = {}) {
    this.entry = opts.entry ?? null;
    this.defaults = opts.defaults ?? {};
    this.duplicateOf = opts.duplicate ?? null;
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }
}

export const entryEditor = new EntryEditorState();
